import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { PaginatedProjectsOutput, ProjectsParams } from "@/types";

interface UseProjectsOptions {
  enabled?: boolean;
}

export function getProjectsQueryOptions(params: ProjectsParams, options?: UseProjectsOptions) {
  const query = buildParams({
    account_id: params.account_id,
    role: params.role,
    page: params.page,
    page_size: params.page_size,
    search: params.search,
    sort_by: params.sort_by,
    sort_dir: params.sort_dir,
    standards: params.standards,
    clients: params.clients,
    assets: params.assets,
    sites: params.sites,
    project_status: params.project_status,
    project_code: params.project_code,
    project_name: params.project_name,
  });

  return {
    queryKey: ["projects", params],
    enabled: options?.enabled,
    queryFn: () => apiFetch<PaginatedProjectsOutput>(`/v1/project${query}`),
  };
}

export function useProjects(params: ProjectsParams, options?: UseProjectsOptions) {
  return useQuery(getProjectsQueryOptions(params, options));
}
